import Main from '@/views/administracion/configuracion/catalogos/tiposobra/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/tiposobra/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const tiposObras = [
  {
    path: 'tipos-obra',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoTiposObra',
        path: '/',
        meta: {
          title: 'Tipos de Obra',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default tiposObras;
